import { RoutePath } from "routes/Route.types"

export const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect"

type PathSlice = { pathname: string; search?: string }

const AUTH_PATH_PREFIXES = [
  RoutePath.LOGIN,
  RoutePath.SIGNUP,
  RoutePath.RESET_PASSWORD,
  RoutePath.CHANGE_PASSWORD,
] as const

const isAuthPath = (pathname: string) =>
  AUTH_PATH_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))

/** Store where the user wanted to go before we sent them to login (full path within the app). */
export const rememberIntendedPath = (loc: PathSlice) => {
  const full = `${loc.pathname}${loc.search ?? ""}`
  sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, full)
}

/**
 * If navigate() carried a `from` location (e.g. from <Navigate state={{ from }} />),
 * persist it when nothing is stored yet — covers edge cases where sessionStorage is unavailable.
 */
export const mergePostLoginRedirectFromRouterState = (state: unknown) => {
  const from = (state as { from?: PathSlice })?.from
  if (!from?.pathname) return
  const candidate = `${from.pathname}${from.search ?? ""}`
  if (!candidate.startsWith("/") || candidate.startsWith("//")) return
  if (sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)) return
  sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, candidate)
}

/** Returns a safe in-app path and clears storage, or null. */
export const takeIntendedPathAfterLogin = ()=> {
  const raw = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
  if (!raw) return null
  const pathnameOnly = raw.split("?")[0]
  if (!pathnameOnly.startsWith("/") || pathnameOnly.startsWith("//")) return null
  if (isAuthPath(pathnameOnly)) return null
  return raw
}
